import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function CircleQuestion({ size = 'md', transparent = false }) {
  // The circle-question element is used across different views, so we support a transparent background variant.
  return (
    <span
      className={classNames(
        'tw-apply-circle-question',
        `tw-apply-circle-question--${size}`,
        !transparent && `tw-apply-circle-question--white`,
      )}
    />
  );
}

CircleQuestion.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
};
